import { BasketParkingOptionProperty } from '@epicuro-next/models/basket';

export const basketParkingOptionsLocale: {
  [key in BasketParkingOptionProperty]: string;
} = {
  [BasketParkingOptionProperty.ParkingDate]: $localize`:cbasket|Parking options basket modal parking date label@@parkingOptionParkingDateLabel:Parking Date`,
  [BasketParkingOptionProperty.ParkingReason]: $localize`:cbasket|Parking options basket modal parking reason label@@parkingOptionParkingReasonLabel:Parking Reason`,
};
